export enum UsersFormTabEnum {
    AccessRules = 'accessRules',
    CompaniesGroup = 'companiesGroup',
    IndividualCompanies = 'individualCompanies',
}
